import React from 'react';
import { Building2, FileText, Tag, Info, Euro } from 'lucide-react';
import { usePropertyData } from '../../../../hooks/usePropertyData';
import FormField from './FormField';
import { Controller, useFormContext } from 'react-hook-form';

interface PropertyBasicInfoSectionProps {
  className?: string;
}

const PropertyBasicInfoSection: React.FC<PropertyBasicInfoSectionProps> = ({ className = '' }) => {
  const { propertyTypes } = usePropertyData();
  const { control, watch } = useFormContext();
  const priceOnRequest = watch('price_on_request') === true;

  return (
    <div className={`bg-white rounded-lg shadow-sm p-6 ${className}`}>
      <div
        className="flex items-center mb-6 pb-2 border-b"
      >
        <Building2 className="h-5 w-5 text-primary mr-2" />
        <h3 className="text-lg font-semibold">Informazioni Principali</h3>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <FormField
          name="title"
          label="Titolo Annuncio"
          icon={FileText}
          required
          placeholder="Es. Appartamento moderno con terrazza"
        />

        <FormField
          name="reference_number"
          label="Riferimento"
          icon={Tag}
          placeholder="Es. MOL001"
          hint="Codice di riferimento interno dell'immobile"
        />

        <FormField
          name="type_id"
          label="Tipologia"
          icon={Building2}
          required
          options={propertyTypes.map(type => ({
            value: type.id,
            label: type.name
          }))}
        />

        <FormField
          name="type"
          label="Contratto"
          icon={Info}
          required
          options={[
            { value: 'vendita', label: 'Vendita' },
            { value: 'affitto', label: 'Affitto' }
          ]}
        />

        <div>
          <FormField
            name="price"
            label={priceOnRequest ? 'Prezzo interno (facoltativo)' : 'Prezzo'}
            type="number"
            icon={Euro}
            required={!priceOnRequest}
            min={1}
            placeholder="Es. 250000"
            hint={priceOnRequest ? 'Il prezzo interno non viene mostrato ai clienti. Lascia vuoto per conservare un valore già salvato.' : undefined}
          />
          <label className="mt-3 flex items-center gap-2 text-sm text-gray-700">
            <Controller
              name="price_on_request"
              control={control}
              defaultValue={false}
              render={({ field }) => (
                <input
                  type="checkbox"
                  checked={field.value === true}
                  onChange={event => field.onChange(event.target.checked)}
                  onBlur={field.onBlur}
                  ref={field.ref}
                  name={field.name}
                  className="rounded border-gray-300 text-primary focus:ring-primary"
                />
              )}
            />
            Trattativa riservata
          </label>
        </div>

        <FormField
          name="extra_costs"
          label="Spese Condominiali"
          icon={Euro}
          placeholder="Es. 100€/mese"
        />
      </div>
    </div>
  );
};

export default PropertyBasicInfoSection;